module.exports = __webpack_public_path__ + "sa.svg?47f10f77fdf3b5f282a515fa72597942";